<div class="logo-wrapper">
    <a href="javascript:void(0)" [routerLink]="['/']">
        <img class="img-fluid for-light" src="assets/images/logo/final-logo.png" alt=""
        style="width: 150px;">
        <img class="img-fluid for-dark" style="width: 150px;" src="assets/images/logo/final-logo.png" alt="">
    </a>

    @if(type == 'sidebar') {
        <ng-content select="[icon]"></ng-content>
    
        <div class="toggle-sidebar" (click)="toggleSidebar()">
            <app-feather-icon [icon]="icon" [class]="'status_toggle middle sidebar-toggle'"></app-feather-icon>
        </div>
    }
</div>

@if(type == 'header') {
    <ng-content></ng-content>
    
    <div class="toggle-sidebar" (click)="toggleSidebar()">
        <app-feather-icon [icon]="icon" [class]="'status_toggle middle sidebar-toggle'"></app-feather-icon>
    </div>
}
